<template>
  <lu-vbox lu-flex class="app-container notificationconfig" style="width: 300px !important;">
    <Spinner ref='spinner' style='z-index:60000 !important'/>
    <lu-item>
      <PageHeader :title='$t("Notification Config")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>

      <lu-item lu-click lu-right style='padding: 15px 0; margin-left: auto'>
        <el-button class="button" icon="el-icon-check" @click.stop='saveNotificationConfig' style='margin-right: 10px;'>{{ $t('action.save') }}</el-button>
      </lu-item>
      <!-- <lu-scroll-area class="notificationconfig" lu-flex :scrollbarWidth='10' > -->
        <el-table
          class='table'
          default-expand-all
          :data="dataTree"
          border
          fit
          style="width: 100%; padding-right: 10px; margin-top:15px;"
          row-key="rowId"
          :tree-props="{ hasChildren: 'hasChildren', children: 'ruleList' }"
          :row-class-name="tableRowClassName"
          height="5px">
          <el-table-column show-overflow-tooltip :label="$t('Rule Type')" sortable prop="typeName" min-width="180">
            <template v-if="!scope.row.isChild" slot-scope="scope">
              <span>{{ scope.row.typeName }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" :label="$t('Key 1')" prop="key1Label" min-width="150">
            <template v-if="scope.row.isChild && scope.row.hasKey1" slot-scope="scope">
              <lu-hbox lu-flex lu-vcenter lu-hcenter>
                <span>{{ scope.row.key1Label }}</span>
                <el-input class='inputauto' maxlength="32" size="small" v-model="scope.row.key1" autosize style="margin-left: 5px; margin-top: 3px;" @input='onKeyChange(scope.row)'></el-input>
              </lu-hbox>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" :label="$t('Key 2')" prop="key2Label" min-width="150">
            <template v-if="scope.row.isChild && scope.row.hasKey2" slot-scope="scope">
              <lu-hbox lu-flex lu-vcenter lu-hcenter>
                <span>{{ scope.row.key2Label }}</span>
                <el-input class='inputauto' maxlength="32" size="small" v-model="scope.row.key2" autosize style="margin-left: 5px; margin-top: 3px;" @input='onKeyChange(scope.row)'></el-input>
              </lu-hbox>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" :label="$t('Param 1')" prop="value1Label" min-width="150">
            <template v-if="scope.row.isChild && scope.row.hasValue1" slot-scope="scope">
              <lu-hbox lu-flex lu-vcenter lu-hcenter>
                <span>{{ scope.row.value1Label }}</span>
                <el-input class='inputauto' maxlength="32" size="small" v-model="scope.row.value1" autosize style="margin-left: 5px; margin-top: 3px;"></el-input>
              </lu-hbox>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" :label="$t('Param 2')" prop="value2Label" min-width="150">
            <template v-if="scope.row.isChild && scope.row.hasValue2" slot-scope="scope">
              <lu-hbox lu-flex lu-vcenter lu-hcenter>
                <span>{{ scope.row.value2Label }}</span>
                <el-input class='inputauto' maxlength="32" size="small" v-model="scope.row.value2" autosize style="margin-left: 5px; margin-top: 3px;"></el-input>
              </lu-hbox>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" :label="$t('Reset')" prop="resetLimit" min-width="100">
            <template v-if="scope.row.isChild" slot-scope="scope">
              <lu-hbox lu-flex lu-vcenter lu-hcenter>
                <!-- <el-input-number class='inputauto' :controls="false" size="small" v-model="scope.row.resetLimit" autosize style="margin-top: 3px;"></el-input-number> -->
                <el-input size="small" v-model="scope.row.resetLimit" autosize style="margin-top: 3px;"></el-input>
              </lu-hbox>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('Active')" prop="isActive" >
            <template v-if="scope.row.isChild" slot-scope="scope">
              <el-checkbox v-model="scope.row.isActive" />
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('Email')" prop="email" >
            <template v-if="scope.row.isChild" slot-scope="scope">
              <el-checkbox v-model="scope.row.email" />
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" :label="$t('Popup')" prop="popup" >
            <template v-if="scope.row.isChild" slot-scope="scope">
              <el-checkbox v-model="scope.row.popup" />
            </template>
          </el-table-column> -->
          <el-table-column align="center" :label="$t('Sound')" prop="sound" min-width="180">
            <template v-if="scope.row.isChild" slot-scope="scope">
              <!-- <el-checkbox v-model="scope.row.sound" /> -->
              <el-select filterable v-model="scope.row.sound" >
                <!-- <el-option v-for='s in sounds' :key='s.id' :value='s.id' :label='s.title' /> -->
                <el-option v-for='s in sounds' :key='s.id' :value='s.id' :label='s.title'>
                  <span style="float: left">{{ s.title }}</span>
                  <el-button style="margin-left: 5px" v-if="s.id !== 0" size="mini" class='icon' icon="el-icon-video-play"  @click='playSound(s.id)'/>
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Actions')" align="center" width="100">
            <template slot-scope="scope">
              <template v-if="scope.row.isChild">
                <lu-hbox lu-hcenter lu-vcenter class='pad-in-5'>
                  <el-tooltip class="item" :effect="styleTooltip" :content="$t('Delete')" placement="left" :enterable="false">
                    <el-button size="mini" class='icon' icon="el-icon-delete"  @click='handleDelete(scope.row)' />
                  </el-tooltip>
                </lu-hbox>
              </template>
              <template v-else-if="scope.row.multiple || (!scope.row.multiple && scope.row.ruleList && scope.row.ruleList.length===0)">
                <lu-hbox lu-hcenter lu-vcenter class='pad-in-5'>
                  <el-tooltip class="item" :effect="styleTooltip" :content="$t('Add')" placement="left" :enterable="false">
                    <el-button size="mini" class='icon' icon="el-icon-plus"  @click='handleAdd(scope.row)' />
                  </el-tooltip>
                </lu-hbox>
              </template>
            </template>
          </el-table-column>
        </el-table>
  </lu-vbox>
</template>

<script>
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import Spinner from '@/components/Spinner'
import { mapGetters } from 'vuex'
import { deepClone } from '@/utils'

export default {
  extends: BaseController,
  name: 'notifications',
  components: { Spinner, PageHeader, LuVbox, LuHbox, LuItem },
  data () {
    return {
      dataTree: [],
      bakDataTree: [],
      seqNewId: 0
    }
  },
  computed: {
    ...mapGetters([ 'theme', 'sounds', 'getSoundById' ]),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    }
  },
  asyncComputed: {
    notificationConfig: {
      get () {
        return this.getNotificationConfig()
      },
      default: {},
    }
  },
  methods: {
    playSound (sound) {
      const fileObj = this.getSoundById(sound)
      if (fileObj && fileObj.fileName) {
        var audio = new Audio(require('@/assets/sounds/' + fileObj.fileName))
        audio.play()
      }
    },
    reload () {
      this.getNotificationConfig()
    },
    tableRowClassName({row, rowIndex}) {
      if (!row.isValid) {
        return 'error-row'
      } else if (rowIndex % 2 === 0) {
        return 'odd-row'
      } else {
        return 'even-row'
      }
    },
    getDataTree (dataList) {
      let arr = []
      if (dataList && dataList.length) {
        for (let i = 0; i < dataList.length; i++) {
          let item = dataList[i]
          if (item) {
            let row = {
              rowId: '' + item.typeId,
              rowIdRef: '' + item.typeId,
              typeId: item.typeId,
              typeName: item.typeName,
              key1Label: item.key1 ? item.key1 : '',
              key2Label: item.key2 ? item.key2 : '',
              value1Label: item.value1 ? item.value1 : '',
              value2Label: item.value2 ? item.value2 : '',
              key1: '',
              key2: '',
              value1: '',
              value2: '',
              multiple: item.multiple,
              ruleList: [],
              isChild: false,
              hasKey1: Boolean(item.key1),
              hasKey2: Boolean(item.key2),
              hasValue1: Boolean(item.value1),
              hasValue2: Boolean(item.value2),
              isValid: true
            }
            arr.push(row)

            if (item.ruleList && item.ruleList.length) {
              for (let j = 0; j < item.ruleList.length; j++) {
                let subItem = item.ruleList[j]
                if (subItem) {
                  row.ruleList.push({
                    rowId: '' + row.typeId + '_' + subItem.id,
                    rowIdRef: row.rowId,
                    typeId: row.typeId,
                    typeName: row.typeName,
                    key1Label: row.key1Label,
                    key2Label: row.key2Label,
                    value1Label: row.value1Label,
                    value2Label: row.value2Label,
                    key1: row.hasKey1 && Boolean(subItem.key1) ? subItem.key1 : '',
                    key2: row.hasKey2 && Boolean(subItem.key2) ? subItem.key2 : '',
                    value1: row.hasValue1 && Boolean(subItem.value1) ? subItem.value1 : '',
                    value2: row.hasValue2 && Boolean(subItem.value2) ? subItem.value2 : '',
                    multiple: row.multiple,
                    id: subItem.id,
                    isActive: subItem.isActive === 1,
                    popup: subItem.popup === 1,
                    email: subItem.email === 1,
                    // sound: subItem.sound === 1,
                    sound: subItem.sound,
                    resetLimit: subItem.resetLimit,
                    isChild: true,
                    hasKey1: row.hasKey1,
                    hasKey2: row.hasKey2,
                    hasValue1: row.hasValue1,
                    hasValue2: row.hasValue2,
                    isValid: true
                  })
                }
              }
            }
          }
        }
      }

      // check errors
      this.initIsValid()
      return arr
    },
    initIsValid () {
      for (let i = 0; i < this.dataTree.length; i++) {
        if (this.dataTree[i] && this.dataTree[i].ruleList && this.dataTree[i].ruleList.length) {
          for (let j = 0; j < this.dataTree[i].ruleList.length; j++) {
            if (this.dataTree[i].ruleList[j]) {
              this.dataTree[i].ruleList[j].isValid = this.getRowIsValidFromObj(this.dataTree[i], this.dataTree[i].ruleList[j])
            }
          }
        }
      }
      return true
    },
    initRowIsValid (row) {
      let indexData = this.getRowIndex(row)
      
      if (this.dataTree[indexData.idxRef] && this.dataTree[indexData.idxRef].ruleList && this.dataTree[indexData.idxRef].ruleList.length) {
        if (this.dataTree[indexData.idxRef].ruleList[indexData.idx]) {
          this.dataTree[indexData.idxRef].ruleList[indexData.idx].isValid = this.getRowIsValidFromObj(this.dataTree[indexData.idxRef], this.dataTree[indexData.idxRef].ruleList[indexData.idx])
        }
      }
    },
    onKeyChange(row) {
      this.initRowIsValid(row)
    },
    getRowIndex (row, getChildIdx = true ) {
      let obj = {}
      if (row) {
        obj.idxRef = this.dataTree.findIndex(item => item.rowId === row.rowIdRef)
        if (obj.idxRef !== -1 && getChildIdx) {
          if (this.dataTree[obj.idxRef] && this.dataTree[obj.idxRef].ruleList && this.dataTree[obj.idxRef].ruleList.length) {
            obj.idx = this.dataTree[obj.idxRef].ruleList.findIndex(item => item.rowId === row.rowId)
          }
        }
      }
      return obj
    },
    getRowIsValid (row) {
      if (!row) return false
      if ((row.hasKey1 && !row.key1) || (row.hasKey2 && !row.key2)) return false

      let indexData = this.getRowIndex(row, false)
      if (indexData.idxRef === -1) return false

      let rowRef = this.dataTree[indexData.idxRef]
      if (rowRef && rowRef.ruleList) {
        let searchIdx = rowRef.ruleList.findIndex(item => item.key1Label === row.key1Label && item.key1 === row.key1 && item.key2Label === row.key2Label && item.key2 === row.key2 && item.rowId !== row.rowId)
        if (searchIdx === -1) return true
      }
      return false
    },
    getRowIsValidFromObj (rowRef, row) {
      if (!row) return false
      if ((row.hasKey1 && !row.key1) || (row.hasKey2 && !row.key2)) return false

      if (rowRef && rowRef.ruleList) {
        let searchIdx = rowRef.ruleList.findIndex(item => item.key1Label === row.key1Label && item.key1 === row.key1 && item.key2Label === row.key2Label && item.key2 === row.key2 && item.rowId !== row.rowId)
        if (searchIdx === -1) return true
      }
      return false
    },
    getRowIsValidFromIndex (idxRef, idx) {
      let rowRef = this.dataTree[idxRef]
      let row = null
      if (this.dataTree[idxRef] && this.dataTree[idxRef].ruleList && this.dataTree[idxRef].ruleList.length) {
        row = this.dataTree[idxRef].ruleList[idx]
      }

      if (!row) return false
      if ((row.hasKey1 && !row.key1) || (row.hasKey2 && !row.key2)) return false

      if (rowRef && rowRef.ruleList) {
        let searchIdx = rowRef.ruleList.findIndex(item => item.key1Label === row.key1Label && item.key1 === row.key1 && item.key2Label === row.key2Label && item.key2 === row.key2 && item.rowId !== row.rowId)
        if (searchIdx === -1) return true
      }
      return false
    },
    getNotificationConfig () {
      return this.$tango.getFunctionData({functionId: 'getNotificationConfig'}).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : Notification Config')
        } else {
          this.dataTree = []
          this.bakDataTree = []
          this.seqNewId = 0
          if (rep.typeList && rep.typeList.length) {
            this.dataTree = this.getDataTree(rep.typeList)
            this.bakDataTree = deepClone(this.dataTree)
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    handleDelete(row) {
      let indexData = this.getRowIndex(row)

      if (indexData.idxRef !== -1 && indexData.idx !== -1) {
        if (this.dataTree[indexData.idxRef] && this.dataTree[indexData.idxRef].ruleList && this.dataTree[indexData.idxRef].ruleList.length) {
          if (this.dataTree[indexData.idxRef].ruleList[indexData.idx]) {
            this.dataTree[indexData.idxRef].ruleList.splice(indexData.idx, 1)
            return true
          }
        }
      }
      return false
    },
    handleAdd(row) {
      let indexData = this.getRowIndex(row, false)
      if (indexData.idxRef === -1) return false

      let newId = this.getNewId()
      let rowRef = this.dataTree[indexData.idxRef]
      if (rowRef && rowRef.ruleList) {
        let newRow = {
          rowId: '' + rowRef.typeId + '_' + newId,
          rowIdRef: rowRef.rowId,
          typeId: rowRef.typeId,
          typeName: rowRef.typeName,
          key1Label: rowRef.key1Label,
          key2Label: rowRef.key2Label,
          value1Label: rowRef.value1Label,
          value2Label: rowRef.value2Label,
          key1: '',
          key2: '',
          value1: '',
          value2: '',
          multiple: rowRef.multiple,
          id: newId,
          isActive: true,
          popup: false,
          email: false,
          // sound: false,
          sound: 0,
          resetLimit: 0,
          isChild: true,
          hasKey1: rowRef.hasKey1,
          hasKey2: rowRef.hasKey2,
          hasValue1: rowRef.hasValue1,
          hasValue2: rowRef.hasValue2,
          isValid: true
        }
        rowRef.ruleList.push(newRow)
        newRow.isValid = this.getRowIsValidFromObj(rowRef, newRow)
      }
    },
    getNewId() {
      this.seqNewId++
      return -this.seqNewId
    },
    canValidate () {
      for (let i = 0; i < this.dataTree.length; i++) {
        if (this.dataTree[i] && this.dataTree[i].ruleList && this.dataTree[i].ruleList.length) {
          let searchIdx = this.dataTree[i].ruleList.findIndex(item => !item.isValid)
          if (searchIdx !== -1) return false
        }
      }
      return true
    },
    cancel () {
      this.dataTree = deepClone(this.bakDataTree)
      this.seqNewId = 0
    },
    saveNotificationConfig () {
      this.$nextTick().then(() => {
        if (this.canValidate()) {
          let ruleList = this.makeDiffRuleList(this.bakDataTree, this.dataTree, (rule1, rule2) => rule1.rowId === rule2.rowId, (r1, r2) => r1.key1 !== r2.key1 || r1.key2 !== r2.key2 || r1.value1 !== r2.value1 || r1.value2 !== r2.value2 || parseFloat(r1.resetLimit) !== parseFloat(r2.resetLimit) || r1.isActive !== r2.isActive || r1.email !== r2.email || r1.popup !== r2.popup || r1.sound !== r2.sound)
          
          if (ruleList.length) {
            this.$refs.spinner.show()

            let cond = {
              functionId: 'setNotificationConfig',
              ruleList: ruleList
            }

            this.$tango.getFunctionData(cond).then(rep => {
              this.$refs.spinner.hide()
              if (rep.resultCode === 0) {
                this.$message({
                  message: 'Set notification config success',
                  type: 'success'
                })
                this.getNotificationConfig()
              }
              else {
                // this.cancel()
                this.$message({
                  message: 'Error set notification config',
                  type: 'error'
                })
                this.getNotificationConfig()
              }
            }).catch(() => {
              this.$refs.spinner.hide()
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: "Invalid rule key"
          })
        }
      })
    },
    makeDiffRuleList (server, client, comp, diff) {
      // comp, diff, arr => rule
      // action : 1 (insert), 2 (update), 3 (delete)

      let arr = []
      if (server && client) {
        for (let i = 0; i < server.length; i++) {
          if (server[i] && server[i].ruleList && client[i] && client[i].ruleList) {
            server[i].ruleList.forEach(b => {
              let idx = client[i].ruleList.findIndex(s => comp(b, s))
              if (idx === -1) {
                //delete
                arr.push(Object.assign({
                  action: 3
                }, this.getRuleBus(b, 3)))
              }
            })
          }
        }
      }
      if (client && server) {
        for (let i = 0; i < client.length; i++) {
          if (server[i] && server[i].ruleList && client[i] && client[i].ruleList) {
            client[i].ruleList.forEach(b => {
              let idx = server[i].ruleList.findIndex(s => comp(s, b))
              if (idx === -1) {
                //insert
                arr.push(Object.assign({
                  action: 1
                }, this.getRuleBus(b, 1)))
              }
              else {
                if (diff) {
                  if (diff(server[i].ruleList[idx], b)) {
                    //update
                    arr.push(Object.assign({
                      action: 2
                    }, this.getRuleBus(b, 2)))
                  }
                }
              }
            })
          }
        }
      }
      return arr
    },
    getRuleBus(b,action) {
      if (action === 3) {
        // delete
        return {
          id: b.id,
          typeId: b.typeId
        }
      } else if (action === 1) {
        // insert
        return {
          typeId: b.typeId,
          key1: b.key1,
          key2: b.key2,
          value1: b.value1,
          value2: b.value2,
          resetLimit: b.resetLimit,
          isActive: b.isActive ? 1 : 0,
          email: b.email ? 1 : 0,
          popup: b.popup ? 1 : 0,
          // sound: b.sound ? 1 : 0,
          sound: b.sound
        }
      } else if (action === 2) {
        // update
        return {
          id: b.id,
          typeId: b.typeId,
          key1: b.key1,
          key2: b.key2,
          value1: b.value1,
          value2: b.value2,
          resetLimit: b.resetLimit,
          isActive: b.isActive ? 1 : 0,
          email: b.email ? 1 : 0,
          popup: b.popup ? 1 : 0,
          // sound: b.sound ? 1 : 0,
          sound: b.sound
        }
      }
      return {}
    }
  }
}
</script>
